import moment from 'moment';

export function getWeek(date: Date): [Date, Date] {
    return [moment(date).startOf('isoWeek').toDate(), moment(date).endOf('isoWeek').toDate()];
}
